// Don't store the settings in an object used like ...settings, as it causes a weird bug where the token doesn't get sent.

import { get } from "svelte/store";
import { isSales, salesCompanyKey } from "../stores.js";

function generateUrl(url) {
    // Check if we need to add the salesCompanyKey parameter

    let companyKey = get(salesCompanyKey);

    if (!url.includes("salesCompanyKey") && get(isSales) && companyKey) {
        // Determine whether the URL already has query parameters
        const hasQuery = url.includes("?");

        // Ensure the URL ends with '/' before query parameters if it doesn't have any
        if (!hasQuery && !url.endsWith("/")) {
            url += "/";
        }

        let encodedCompanyKey = encodeURIComponent(companyKey);

        // Append the parameter correctly based on whether there are existing query parameters
        if (hasQuery) {
            url += `&salesCompanyKey=${encodedCompanyKey}`;
        } else {
            url += `?salesCompanyKey=${encodedCompanyKey}`;
        }
    }

    return url;
}

export async function fetchGet(url) {
    try {
        let result = await (
            await fetch(generateUrl(url), {
                method: "GET",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchPost(url, data) {
    try {
        let result = await (
            await fetch(generateUrl(url), {
                method: "POST",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchPatch(url, data) {
    try {
        let result = await (
            await fetch(generateUrl(url), {
                method: "PATCH",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchDelete(url) {
    try {
        let result = await (
            await fetch(generateUrl(url), {
                method: "DELETE",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchGetFile(url, formData) {
    try {
        let result = await fetch(generateUrl(url), {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
                Authorization: localStorage.getItem("token"),
            },
        });

        return result;
    } catch (err) {
        return err;
    }
}

// export async function fetchPostFile(url, formData) {
//     try {
//         let result = await (
//             await fetch(generateUrl(url), {
//                 method: "POST",
//                 withCredentials: true,
//                 credentials: "include",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                     // Accept: "application/json",
//                     // "Content-type": "multipart/form-data",
//                 },
//                 body: formData,
//             })
//         ).json();

//         return result;
//     } catch (err) {
//         return err;
//     }
// }
